import { createAction, props } from '@ngrx/store';

import { Client } from '@lockton-apps/shared/interfaces';

import { ClientsActionTypes } from './clients.models';

export const loadClientSubClients = createAction(
  ClientsActionTypes.LoadClientSubClients,
  props<{ clientId: number }>()
);

export const loadClientSubClientsSuccess = createAction(
  ClientsActionTypes.LoadClientSubClientsSuccess,
  props<{ clients: Client[] }>()
);

export const loadClientSubClientsFailure = createAction(
  ClientsActionTypes.LoadClientSubClientsFailure,
  props<{ error: unknown }>()
);
